import { defineAsyncComponent } from 'vue'
export default {
  "bio-tools-manual": defineAsyncComponent(() => import("/var/www/rare-database/layouts/bio-tools-manual.vue").then(m => m.default || m)),
  "bio-tools": defineAsyncComponent(() => import("/var/www/rare-database/layouts/bio-tools.vue").then(m => m.default || m)),
  "main-big": defineAsyncComponent(() => import("/var/www/rare-database/layouts/main/big.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/var/www/rare-database/layouts/main/index.vue").then(m => m.default || m)),
  "main-small": defineAsyncComponent(() => import("/var/www/rare-database/layouts/main/small.vue").then(m => m.default || m))
}